module.exports = __webpack_public_path__ + "media/images/flags/16/Montenegro-4de494ff90241819948829242710bcd8.png";